export default "__VITE_ASSET__DsMhFGub__"